import React from 'react';
import { FlexBox, BoldSmallerParagraph } from '../../../Components';
import styles from './OrderMatrixHeader.module.scss';
import { HeaderItem } from './Item';

export const OrderMatrixHeader = ({ length, sizes }) => (
  <FlexBox flex={1} className={styles.header}>
    <HeaderItem>
      <BoldSmallerParagraph>
        {(length || '').toUpperCase()}
      </BoldSmallerParagraph>
    </HeaderItem>
    {sizes.map((s) => (
      <HeaderItem key={s}>
        <BoldSmallerParagraph>{s}</BoldSmallerParagraph>
      </HeaderItem>
    ))}
    <FlexBox className={styles.placeholder} />
  </FlexBox>
);
